export default __webpack_public_path__ + "static/media/qr-background.bfe3f5d3.png";